import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowRight = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.675 13H4.5V11H16.675L11.075 5.4L12.5 4L20.5 12L12.5 20L11.075 18.6L16.675 13Z" />
    </SvgIcon>
  );
};

export default ArrowRight;